import config from "../configuration";

export abstract class TemplateInstance {
  FirstText?: string;
  SecondText?: string;
  ImageIdentifier?: string;

  constructor(
    firstText?: string,
    secondText?: string,
    imageIdentifier?: string
  ) {
    this.FirstText = firstText;
    this.SecondText = secondText;
    this.ImageIdentifier = imageIdentifier;
  }

  async setImageIdentifier(imageIdentifier: string): Promise<void> {
    this.ImageIdentifier = await ImageHandler(imageIdentifier);
  }
}

const ImageHandler = async (imageIdentifier: string): Promise<string> => {
  if (imageIdentifier === config.General1) return "General1.png";
  else throw new Error("Wrong image identifier received.");
};
